module.exports = __webpack_public_path__ + "img/WG.c0943cf1.png";